import React from "react";
import Colors from "../../stories/assets/Colors";
import { RangeSliderIcon } from "../../constant/imagePath";
import classes from "./RangePickerWithGraph.module.css";

import {
  RangeSlider,
  RangeSliderTrack,
  RangeSliderFilledTrack,
  RangeSliderThumb,
} from "@chakra-ui/react";

const RangeArray = [
  6, 6, 6, 6, 6, 28, 28, 48, 48, 60, 60, 60, 48, 48, 28, 28, 6, 6, 6, 6, 20, 20,
  6, 6, 6, 6, 28, 28, 28, 28, 28, 6, 6, 6, 6, 20, 20, 20, 6, 6, 6, 6, 48, 48,
  60, 60, 60, 20, 20, 6,
];

export default function RangePickerWithGraph({
  isMulti,
  value,
  setValue,
  min = 10,
  max = 1000,
}) {
  console.log({ value });
  const HandleValueChange = (data) => {
    // console.log(data);
    if (isMulti) {
      setValue(data);
      // console.log(data);
    } else {
      // console.log(data[1]);

      setValue(data[1]);
    }
  };
  return (
    <div className={classes.rangesWithPicker}>
      <div className={`${[classes.ranges].join(" ")}`}>
        {RangeArray?.map((item, index) => {
          let minval = isMulti === true ? value[0] / 20 : 0;
          let maxval = isMulti === true ? value[1] / 20 : value / 20;
          let isExist = index + 1 > minval && index + 1 < maxval ? true : false;
          return (
            <div
              className={classes.picker}
              style={{
                backgroundColor: isExist
                  ? Colors.neutralShadesOfGainsboro
                  : Colors.neutralShadesOfWhisper,
                height: item + "px",
              }}
            />
          );
        })}
      </div>
      {/* Picker */}
      <div className={`${[classes.rangePicker].join(" ")}`}>
        <RangeSlider
          aria-label={["min", "max"]}
          defaultValue={isMulti ? value : [min, value]}
          onChange={(e) => {
            HandleValueChange(e);
          }}
          value={isMulti ? value : [min, value]}
          min={min}
          max={max}
        >
          <RangeSliderTrack bg={Colors.neutralShadesOfWhisper}>
            <RangeSliderFilledTrack bg={Colors.neutralShadesOfGainsboro} />
          </RangeSliderTrack>

          <RangeSliderThumb
            boxSize={6}
            index={0}
            className={classes.thumb}
            style={{
              backgroundColor: "none",
              background: `url(${RangeSliderIcon})`,
              border: "none",
              borderRadius: 0,
              boxShadow: "none",
              display: isMulti ? "flex" : "none",
            }}
          ></RangeSliderThumb>

          <RangeSliderThumb
            boxSize={6}
            index={1}
            style={{
              backgroundColor: "none",
              background: `url(${RangeSliderIcon})`,
              border: "none",
              borderRadius: 0,
              boxShadow: "none",
            }}
            className={classes.thumb}
          ></RangeSliderThumb>
        </RangeSlider>
      </div>
    </div>
  );
}
